import { render, staticRenderFns } from "./formsTemplate.vue?vue&type=template&id=06c6074c&scoped=true&"
import script from "./formsTemplate.vue?vue&type=script&lang=js&"
export * from "./formsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./formsTemplate.vue?vue&type=style&index=0&id=06c6074c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6074c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
